import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';


@Injectable()
export class GroupStudentService extends ServiceGlobal {
    group_file_id: any;
    group_id: any;
    file_id: any;
    type: any;
    remarks : any;
    api_find_all: any = 'group_students';
    api_find_one: any = 'group_students';
    api_delete: any  = 'group_students';
    loading: any = false;
    primary_key: any = 'group_student_id';
    tableName() { return 'group_students'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "group_student_id": "group_student_id",
            "group_id" : "group_id",
            "student": "student",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "group_file_id": {
                "type": "any",
                "auto_increment": true,
                "primary_key": true,
            },
            "group_id": {
                "type": "any",
                "require": {
                    "empty": true
                },
            },
            "student": {
                "type": "any",
                "require": {
                    "empty": true
                },
            },
        });
    }

    save(update=false) {
        var link = API.CREATE_GROUP_FILES;
        let attrs = this.getAttributes();
        if(update) {
            attrs = this.getAttributesUpdate();
            return this._db.put(link, attrs);
        }
        return this._db.post(link, attrs);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/group_student.service.ts